import { AS } from "../namespaces";

export type TestingStatus = { activated: boolean; text: string };

export interface AssetsTesting {
  /**
 *
 */
  testing: {
    /**
 *
 *
 *
 */
    activate: () => string;
    /**
 *
 *
 *
 */
    deactivate: () => string;
    /**
 *
 *
 *
 *
 */
    status: () => TestingStatus;
  };
}

/**
 *
 *
 *
 *
 */
function getStatus(): TestingStatus {
  window.AS.RUM.sendCustomRequest("AssetsLegacyASTestingGetStatus", { stack: Error().stack });

  if (document.cookie.match(/AS_testing=true/i)) {
    return { activated: true, text: "activated" };
  }
  return { activated: false, text: "deactivated" };
}

/**
 *
 *
 *
 */
function activate(): string {
  window.AS.RUM.sendCustomRequest("AssetsLegacyASTestingActivate", { stack: Error().stack });

  if (!getStatus().activated) {
    document.cookie = "AS_testing=true";
  }

  return getStatus().text;
}

/**
 *
 *
 *
 */
function deactivate(): string {
  window.AS.RUM.sendCustomRequest("AssetsLegacyASTestingDeactivate", { stack: Error().stack });

  if (getStatus().activated) {
    document.cookie = `AS_testing=; expires=${new Date().toUTCString()}`;
  }

  return getStatus().text;
}

/**
 *
 *
 *
 */
AS.testing = { activate, deactivate, status: getStatus };
